import { VariantExchangeGuidanceSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/variant-exchange-guidance";
import * as z from "zod";

export const updateVariantExchangeGuidance = {
  name: "updateVariantExchangeGuidance" as const,
  input: z.object({
    variantExchangeGuidance: z.array(VariantExchangeGuidanceSchema),
  }),
  output: z.object({}),
};
